import { useEffect, useState } from 'react'

const useObjectUrl = (file: File | Blob | undefined): string | undefined => {
  const [objectUrl, setObjectUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!file) {
      setObjectUrl(undefined)
      return undefined
    }
    const url = URL.createObjectURL(file)
    setObjectUrl(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  return objectUrl
}

export default useObjectUrl
